var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: {
        value: true,
        persistent: "",
        "content-class": "welcomedialog",
        "max-width": "400",
      },
    },
    [
      _c(
        "v-card",
        { staticStyle: { width: "400px" } },
        [
          _c("br"),
          _c(
            "div",
            { staticClass: "primary--text", attrs: { align: "center" } },
            [
              _c("h1", [
                _vm._v(
                  _vm._s(_vm.$t("greeting")) + ", " + _vm._s(_vm.name) + "!"
                ),
              ]),
            ]
          ),
          _c("br"),
          _vm.pic != "" && _vm.pic != null
            ? _c("v-img", {
                style: { cursor: "pointer" },
                attrs: { src: _vm.pic, "aspect-ratio": 16 / 9, contain: "" },
              })
            : _vm._e(),
          _c("br"),
          _vm.message != ""
            ? _c("div", [_c("h2", [_vm._v(_vm._s(_vm.message))])])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }